import React, { useEffect, useState } from "react";
import { Grid, Box, Typography, Avatar, Checkbox } from "@mui/material";
import "./CreateGoalModal.css";
import CustomModal from "../../CustomModal/CustomModal";
import ModalFooter from "../../CustomModal/ModalFooter";
import ModalHeader from "../../CustomModal/ModalHeader";
import SearchComponent from "../../../components/SearchComponent";
import CustomTextField from "../../../components/CustomTextField/CustomTextField";
import CustomDatePicker from "../../../components/CustomDatePicker/CustomDatePicker";
import CustomAutoComplete from "../../../components/CustomAutoComplete/CustomAutoComplete";

import CompDirection from "../../../themes/CompDirection";
import { fonts } from "../../../themes/themes";
interface ModalProps {
  isModalOpen?: boolean;
  closeModal: any;

  trans?: any;
}

const CreateGoalModalPresenter = ({
  isModalOpen,
  closeModal,

  trans,
}: ModalProps) => {
  return (
    <CustomModal isModalOpen={isModalOpen} modalHeight="75vh" modalWidth="60vw">
      <ModalHeader
        modal={{ modal_title: trans("Create Goal") }}
        closeModal={closeModal}
      />
      <CompDirection>
        <Grid
          spacing={2}
          container
          sx={{
            marginTop: "15px",
          }}
        >
          <Grid item xs={4}>
            <Box
              style={{
                backgroundColor: "#FAFAFA",
                padding: "1em",
                borderRadius: "7px",
              }}
            >
              <Box
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <Typography
                  style={{
                    color: "#575757",
                    fontFamily: fonts.fontFamily,
                    fontSize: "0.725em",
                    fontWeight: "bold",
                  }}
                >
                  Goal 1
                </Typography>
                <Typography>
                  <i className="las la-angle-up" style={{ color: "#575757" }} />
                </Typography>
              </Box>

              <Box
                style={{
                  backgroundColor: "white",
                  padding: "1em",
                  borderRadius: "8px",
                }}
              >
                <CustomTextField type="string" label="Goal Name" />
                <Box style={{ marginTop: "1em" }} />
                <CustomDatePicker label="Start From" />
                <Box style={{ marginTop: "1em" }} />
                <CustomDatePicker label="Due Date" />
                <Box style={{ marginTop: "1em" }} />
                <CustomAutoComplete label="Status" />
                <Box style={{ marginTop: "1em" }} />
                <CustomTextField type="string" label="Goal Description" />
              </Box>
            </Box>
          </Grid>
          <Grid item xs={4}>
            <Box
              style={{
                border: "1px solid #0000001F",
                padding: "1em",
                borderRadius: "7px",
              }}
            >
              <Typography
                style={{
                  color: "#575757",
                  fontFamily: fonts.fontFamily,
                  fontSize: "0.725em",
                  fontWeight: "bold",
                }}
              >
                GOAL CATEGORY
              </Typography>
              <Typography
                style={{
                  color: "#575757",
                  fontFamily: fonts.fontFamily,
                  fontSize: "0.725em",
                }}
              >
                2/4 selected
              </Typography>
              <Box style={{ marginTop: "0.5em" }} />
              <SearchComponent />
              <Box style={{ marginTop: "0.5em" }} />
              {[
                { id: 1, name: "UX Designer" },
                { id: 2, name: "Full Stack Develpoer" },
                { id: 3, name: "PRO" },
                { id: 4, name: "HR Manager" },
                { id: 5, name: "Sales Executive" },
              ].map((data: any, index: any) => {
                return (
                  <Box
                    key={data?.id}
                    style={{
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <Box>
                      <Checkbox />
                    </Box>

                    <Box>
                      <Typography
                        style={{
                          fontSize: "0.75em",
                          color: "#575757",
                          fontFamily: fonts.fontFamily,
                        }}
                      >
                        {data?.name}
                      </Typography>
                    </Box>
                  </Box>
                );
              })}
            </Box>
          </Grid>
          <Grid item xs={4}>
            <Box
              style={{
                border: "1px solid #0000001F",
                padding: "1em",
                borderRadius: "7px",
              }}
            >
              <Typography
                style={{
                  color: "#575757",
                  fontFamily: fonts.fontFamily,
                  fontSize: "0.725em",
                  fontWeight: "bold",
                }}
              >
                Assign Employees
              </Typography>
              <Typography
                style={{
                  color: "#575757",
                  fontFamily: fonts.fontFamily,
                  fontSize: "0.725em",
                }}
              >
                5/12 selected
              </Typography>
              <Box style={{ marginTop: "0.5em" }} />
              <SearchComponent />
              <Box style={{ marginTop: "0.5em" }} />
              {[
                { id: 8987, name: "Amelia gg" },
                { id: 1542, name: "Tapook Lio" },
                { id: 6875, name: "Othman Api" },
                { id: 3624, name: "Arib Gozeel" },
                { id: 1152, name: "Durkhush Falo" },
              ].map((data: any, index: any) => {
                return (
                  <Grid
                    container
                    spacing={2}
                    key={data?.id}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      fontFamily: fonts.fontFamily,
                    }}
                  >
                    <Grid item xs={3}>
                      <Checkbox />
                    </Grid>
                    <Grid item xs={3}>
                      <Typography
                        style={{
                          fontSize: "0.75em",
                          color: "#575757",
                          fontFamily: fonts.fontFamily,
                        }}
                      >
                        {" "}
                        {data?.id}
                      </Typography>
                    </Grid>
                    <Grid item xs={3}>
                      <Avatar />
                    </Grid>
                    <Grid item xs={3}>
                      <Typography
                        style={{
                          fontSize: "0.75em",
                          color: "#081735",
                          fontWeight: "bold",
                        }}
                      >
                        {data?.name}
                      </Typography>
                    </Grid>
                  </Grid>
                );
              })}
            </Box>
          </Grid>
        </Grid>
      </CompDirection>

      <Box style={{ marginTop: "35px" }} />
      <ModalFooter
        onClickCancel={() => {
          closeModal();
        }}
      />
    </CustomModal>
  );
};

export default CreateGoalModalPresenter;
